import script from "./UrlDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./UrlDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./UrlDisplay.vue?vue&type=style&index=0&id=b1054882&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1054882"]])

export default __exports__